<ul class="tabs">
  <!-- <li [class.is--active]="active === 'project-search'"><a [routerLink]="'/projects/page/1'">Filters</a></li> -->
  <!-- <li [class.is--active]="active === 'detail-search'"><a [routerLink]="'/details/page/1'">Details</a></li> -->
</ul>
